import Vue from 'vue';
import VeeValidate from 'vee-validate';
var VueValidationRu = require('vee-validate/dist/locale/ru');

Vue.use(VeeValidate, {
  locale: 'ru',
  dictionary: {
    ru: VueValidationRu
  }
});


//////////////////
// WEBPACK FOOTER
// ./plugins/validate.js
// module id = ./plugins/validate.js
// module chunks = 152